<template>
<v-card
    class="mx-auto my-3"
>
    <div
        style="text-align: center"
    >
        <v-icon
            size="245"
            v-if="value.comp_logo_blob_urls.length == 0"
        >
            mdi-apple-icloud
        </v-icon>

        <img
            v-else
            :src="value.comp_logo_blob_urls[0]"
            style="max-width: 245px; max-height: 245px; margin-top: 30px;"
        />
    </div>

    <v-card-title>{{value.app_label}}</v-card-title>

    <v-card-text>
    
      <div>
        <b>Description</b><br/>
        {{value.app_description_md}}
      </div>

      <div
        style="margin-top: 15px"
      >  
        <b>Permissions</b>
        <div
          ref="permission_list"
        >
          <ul>
              <li
                  v-for="(p, index) in value.permissions"
                  :key="'perm'+index"
              >
                  {{$rc.pretty(p,'enum_app_permission')}}
              </li>
          </ul>
        </div>
      </div>

    </v-card-text>

    <v-card-actions>
    <v-spacer/>
      <v-btn
        text
        @click="onClickUnInstall"
        v-if="value.installed_version != null"
      >
        Uninstall
      </v-btn>

      <v-btn
        color="primary"
        text
        @click="onClickInstall"
        v-if="value.installed_version == null"
      >
        Install
      </v-btn>

      <v-btn
        color="primary"
        text
        @click="onClickUpgrade"
        v-if="value.installed_version != null && value.installed_version != value.version"
      >
        Upgrade
      </v-btn>
    </v-card-actions>

</v-card>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },
    },

    methods: {
      onClickInstall() 
      {
        let permission_list_html = this.$refs['permission_list'].innerHTML;

        this.$rc.confirm({
          'title': 'Confirm Installion',
          'body': 'Install '+this.value.app_label+' and grant it all of its requested permissions?<br/><br/>Requested Permissions:<br/>'+permission_list_html,
          'btn_text_ok': 'Install',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.doInstall();
          },
        });  
      },

      onClickUpgrade()
      {
        let permission_list_html = this.$refs['permission_list'].innerHTML;

        this.$rc.confirm({
          'title': 'Confirm Upgrade',
          'body': 'Upgrade '+this.value.app_label+' to its latest version and grant it all of its requested permissions?<br/><br/>Requested Permissions:<br/>'+permission_list_html,
          'btn_text_ok': 'Upgrade',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.doInstall();
          },
        });  
      },

      doInstall()
      {
        this.$rc.rest({
          'spinner': false,
          'endpoint': 'PUT: /api/v1/app/store/do-install',
        
          'params' : this.value,
        
          'on_success': (data) => {
              this.$emit('input', this.value);
              this.$rc.alertMarkdown(this.value.after_install_title, this.value.after_install_detail_md);
            },
        
          'on_error': 'Unable to install app',
        });
      },

      onClickUnInstall()
      {
        this.$rc.confirm({
          'title': 'Confirm Uninstall App',
          'body': 'Uninstall '+this.value.app_label+'?',
          'btn_text_ok': 'Uninstall',
          'btn_text_cancel': 'Cancel',
          'on_ok': () => {
            this.doUninstall();
          },
        });  
      },

      doUninstall()
      {
        this.$rc.rest({
          'spinner': false,
          'endpoint': 'PUT: /api/v1/app/store/do-uninstall',
        
          'params' : this.value,
        
          'on_success': (data) => {
              this.$emit('input', this.value);
              this.$rc.alert('App Uninstalled', 'You have uninstalled '+this.value.app_label);
            },
        
          'on_error': 'Unable to uninstall app',
        });
      },
    },
}
</script>

<style lang="scss" scoped>

</style>